// extracted by mini-css-extract-plugin
export default {"hideTooltip":"s--z","fadeIn":"t--z","delay":"u--z","recommendedSizeTooltip":"v--z"};